import React from 'react';
import { Path, Rect, Circle, Line, Polygon, Polyline, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const CommentIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path
      d="M17.2286 13.1143V0.771429H0.771429V17.2286L4.88571 13.1143H17.2286Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Svg>
);

CommentIcon.displayName = 'CommentIcon';
